// extracted by mini-css-extract-plugin
module.exports = {"banner":"Startups_banner__3jZyF","btn":"Startups_btn__zGKuq","itemsOnImg":"Startups_itemsOnImg__zZsfT"};